// extracted by mini-css-extract-plugin
module.exports = {"videoFrame":"_3pNB3QG6bPQJlX0hVK-sqE"};